import {Component} from 'react';
import h from 'react-hyperscript';
import {h3, h4, p} from 'Components/Typography/Typography';
import BasicCard from 'Components/Cards/BasicCard';
import ErrorMessage from 'Components/ErrorMessage/ErrorMessage';
import {ENDPOINTS} from 'Src/utils/utils';
import './OptIn.scss';
import content from 'Assets/data/globals.json';

class OptIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showCancel: false,
    };

    this.optIn = this.optIn.bind(this);
    this.optOut = this.optOut.bind(this);
    this.intendOptOut = this.intendOptOut.bind(this);
    this.cancelOptOut = this.cancelOptOut.bind(this);
  }

  optIn() {
    this.postOptIn(true);
  }

  optOut() {
    this.postOptIn(false);
  }

  postOptIn(isOptingIn) {
    const idToken = this.props.googleUser.getAuthResponse().id_token;
    fetch(ENDPOINTS.OPT_IN, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': idToken,
        'X-CSRF-Token': this.props.csrf,
      },
      body: JSON.stringify({
        opt_in_flag: isOptingIn,
      }),
    })
        .then((response) => {
          return response.json();
        })
        .then((result) => {
          if (this.props.handleOptedIn) {
            this.props.handleOptedIn(Boolean(result.date), !isOptingIn);
          }
        }, (error) => {
          this.setErrorMessage(content.errors.fetch);
        }
        );
  }

  intendOptOut() {
    this.setState({
      showCancel: true,
    });
  }

  cancelOptOut() {
    this.setState({
      showCancel: false,
    });
  }

  setErrorMessage(value) {
    this.setState({
      errorMessage: value,
    });
  }

  render() {
    const card = this.state.showCancel ?
      this.renderOptOut() :
      this.renderOptIn();

    if (this.state.errorMessage) {
      return (
        h(ErrorMessage, {
          message: this.state.errorMessage,
        }, null)
      );
    } else {
      return (
        h('div', {
          className: 'opt-in__container container flex--wrap-all',
          id: 'opt-in',
        },
        h(BasicCard, {
          className: 'opt-in__inner',
        }, card)
        )
      );
    }
  }

  renderOptIn() {
    const copy = content.opt_in.confirm;

    return [
      h(h3, {
        className: 'text--dark padding-bottom--lg',
      }, copy.title),
      h(h4, {
        className: 'text--dark padding-bottom--sm',
      }, copy.subtitle),
      h(p, {
        className: 'text--grey padding-bottom--md',
      }, [
        copy.desc.partOne,
        h('a', {
          href: copy.desc.partTwo.href,
          alt: copy.desc.partTwo.alt,
          target: '_blank',
        }, copy.desc.partTwo.text),
        copy.desc.partThree,
        h('a', {
          href: copy.desc.partFour.href,
          alt: copy.desc.partFour.alt,
          target: '_blank',
        }, copy.desc.partFour.text),
        copy.desc.partFive,
      ]),
      h('div', {
        className: 'flex flex--end opt-in__buttons',
      }, [
        h('div', {
          'className': 'button button--basic',
          'data-g-label': copy.buttons.agree.attributes.label,
          'data-g-action': copy.buttons.agree.attributes.action,
          'data-g-event': copy.buttons.agree.attributes.event,
          'onClick': this.optIn,
        }, copy.buttons.agree.text),
        h('div', {
          'className': 'button button--secondary',
          'data-g-label': copy.buttons.disagree.attributes.label,
          'data-g-action': copy.buttons.disagree.attributes.action,
          'data-g-event': copy.buttons.disagree.attributes.event,
          'onClick': this.intendOptOut,
        }, copy.buttons.disagree.text),
      ]),
    ];
  }

  renderOptOut() {
    const copy = content.opt_in.cancel;

    return [
      h(h3, {
        className: 'text--dark padding-bottom--lg',
      }, copy.title),
      h(h4, {
        className: 'text--dark padding-bottom--sm',
      }, copy.subtitle1),
      h(p, {
        className: 'text--grey padding-bottom--lg',
      }, copy.desc1),
      h(h4, {
        className: 'text--dark padding-bottom--sm',
      }, copy.subtitle2),
      h(p, {
        className: 'text--grey padding-bottom--lg',
      }, copy.desc2),
      h('div', {
        className: 'flex flex--end opt-in__buttons',
      }, [
        h('div', {
          'className': 'button button--basic',
          'data-g-label': copy.buttons.back.attributes.label,
          'data-g-action': copy.buttons.back.attributes.action,
          'data-g-event': copy.buttons.back.attributes.event,
          'onClick': this.cancelOptOut,
        }, copy.buttons.back.text),
        h('div', {
          'className': 'button button--secondary',
          'data-g-label': copy.buttons.confirm.attributes.label,
          'data-g-action': copy.buttons.confirm.attributes.action,
          'data-g-event': copy.buttons.confirm.attributes.event,
          'onClick': this.optOut,
        }, copy.buttons.confirm.text),
      ]),
    ];
  }
}

export default OptIn;
